import React from 'react';

const ToastContainer = ({ toasts, removeToast }) => {
    if (!toasts?.length) return null;
    
    return (
        <div className="toast-container">
            {toasts.map(toast => (
                <div 
                    key={toast.id} 
                    className={`toast ${toast.type} show`}
                    onClick={() => removeToast(toast.id)}
                    role="alert"
                >
                    <span className="toast-icon">
                        {toast.type === 'success' ? '✓' : toast.type === 'error' ? '✕' : 'ℹ'}
                    </span>
                    <span className="toast-message">{toast.message}</span>
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;